<template>
  <div class="div-conteudo">
    <transition name="modal" v-if="carregando">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
            <label>Aguarde. Carregando.</label>
          </div>
        </div>
      </div>
    </transition>
    <div class="fora" v-else>
      <div class="index centro">
        <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />
        <div class="topo-index">
          <h1>Respostas</h1>
          <router-link v-if="podeEscrever('respostas')" :to="{ name: 'RespostaNew' }">
            <span>+</span> Nova Resposta
          </router-link>
        </div>
        <div class="caixa-pesquisa">
          <h2 @click="tooglePesquisa()">
            Pesquisa
            <span>
              <template v-if="!exibirPesquisa">&#9650;</template>
              <template v-else>&#9660;</template>
            </span>
          </h2>
          <transition name="slide">
            <form @submit.prevent="fazerBusca" v-if="!exibirPesquisa">
              <div class = "row2-data">
                <div class="item">
                  <label> Texto da Resposta: </label>
                  <input type="text" placeholder="Digite o texto para buscar" v-model="filtro.texto" />
                </div>
                <div class="item">
                  <label> Status: </label>
                  <select v-model="filtro.ativo">
                    <option :value="null">Todos</option>
                    <option :value="true">Ativo</option>
                    <option :value="false">Inativo</option>
                  </select>
                </div>
              </div>
              <div class="botoes-pesquisa">
                <div class="bt-pesquisa">
                  <button title="Pesquisar" type="submit">
                    <img src="../../assets/imagens/pesquisa.png" class="pesquisa" alt=" " />
                    Pesquisar
                  </button>
                </div>
                <div class="bt-limpar">
                  <button title="Limpar" @click="limparFiltro()">
                    <img src="../../assets/imagens/icon-eraser.png" class="limpar" alt=" " />
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </form>
          </transition>
        </div>
        <div class="n-div">
          <div class="nresultados" v-show="!carregando">
            <label>Total de Resultados: {{ this.totalResultadosTexto }}</label>
          </div>
          <div class="npagina" v-show="!carregando">
            <label>Resultados por Página </label>
            <select :value="qtd_por_pagina" @input="mudouQtdPagina">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          </div>
        </div>
        <div class="container-tabela">
          <TabelaResultadosRespostas :respostas="respostas" v-if="!carregando && !erro && !erroFiltro" />
        </div>
        <paginate v-if="!carregandoFiltro && !carregando" v-model="pagina" :page-count="pageCount"
            :click-handler="mudouPagina" :prev-text="'Anterior'" :next-text="'Próxima'" :container-class="'className'"
            active-class="active-page"></paginate>
      </div>
    </div>
  </div>
</template>

<script>
  import Paginate from "vuejs-paginate";
  import tryParseInt from "../../helpers/tryParseInt";
  import metaDados from "../../helpers/metaDados";


  import TabelaResultadosRespostas from "../../components/respostas/TabelaResultadosRespostas.vue";
  import RespostaApi from "../../services/RespostaApi";
  import MsgErroFormularios from "../../components/MsgErroFormularios.vue";

  export default {

    name: "Respostas",
    metaInfo() {
        return {
        title: "Respostas",
        titleTemplate: "%s - Casa Civil do Estado de Goiás",
        meta: [
            {
            vmid: "description",
            name: "description",
            content: "Página de listagem e busca de respostas.",
            },            
            ...metaDados(this.$route),
        ],
        };
    },
    data() {
      return {
        respostas: [],
        carregando: true,
        msgErros: {
          resposta: '',
        },
        erro: false,
        totalResultados: null,
        totalResultadosTexto: null,
        pagina: 1,
        qtd_por_pagina: 10,
        filtro: {
          texto: null,
          ativo: null,
        },
        exibirPesquisa: true,
        carregandoFiltro: false,
        erroFiltro: false,
      };
    },
    components: {
      MsgErroFormularios,
      TabelaResultadosRespostas,
      Paginate,
    },
    created() {
      this.respostaApi = new RespostaApi();
      this.carregarQtdPorPagina();
      this.carregarValoresFiltro();
      this.carregarRespostas(); 
    },
    watch: {
      $route: function (to, from) {
        const mudouQuery =
          to.query.pagina != from.query.pagina ||
          to.query.qtd_por_pagina != from.query.qtd_por_pagina ||
          to.query.texto != from.query.texto ||
          to.query.ativo != from.query.ativo
        if (
          from.name == "Respostas" &&
          to.name == "Respostas" &&
          mudouQuery
        ) {
          this.carregarValoresFiltro();
          this.carregarRespostas();
        }
      },
    },
    methods: {
      tooglePesquisa: function () {
        this.exibirPesquisa = !this.exibirPesquisa;
      },
      fazerBusca() {
        this.$router.push({
          name: "Respostas",
          query: {
            ...this.filtro,
            pagina: 1,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        });
      },
      mudouQtdPagina: function (event) {
        const novaQtdPagina = parseInt(event.target.value);
        this.qtd_por_pagina = novaQtdPagina;
        this.mudouPagina(1);
      },
      getParam: function (name) {
        if (this.$route && this.$route.query) {
          return this.$route.query[name];
        }
        return null;
      },
      mudouPagina: function (page) {
        this.pagina = page;
        this.$router.push({
          name: "Respostas",
          query: {
            ...this.filtro,
            pagina: this.pagina,
            qtd_por_pagina: this.qtd_por_pagina,
          },
        });
      },
      carregarValoresFiltro: async function () {
      },
      carregarRespostas: async function () {
        try {
          this.carregando = true;
          this.erro = false;

          this.qtd_por_pagina = this.getParam("qtd_por_pagina") || this.qtd_por_pagina;
          this.armazenarQtdPorPagina();
          this.pagina = parseInt(this.getParam("pagina") || 1);

          this.filtro = {
            texto: this.getParam("texto"),
            ativo: this.getParam("ativo"),
          };

          if (this.respostaApi.cancelTokens.getRespostas) {
            this.respostaApi.cancelTokens.getRespostas.cancel();
          }

          let data = await this.respostaApi.getRespostas({
            ...this.filtro,
            qtd_por_pagina: this.qtd_por_pagina,
            page: this.pagina,
          });

          this.respostas = data.resultados;
          this.totalResultados = data.total_resultados;
          this.totalResultadosTexto = data.total_resultados;
          this.carregando = false;

        } catch (err) {
          if (this.respostaApi.isCancel(err)) {
            return;
          }
          console.log("carregarRespostas", err);
          this.carregando = false;
          this.erro = true;
        }
      },
      limparFiltro: function () {
        this.filtro = {
          texto: null,
          ativo: null,
        };
        this.fazerBusca();
      },
      armazenarQtdPorPagina() {
        localStorage.setItem("qtd_por_pagina_respostas", this.qtd_por_pagina);
      },
      carregarQtdPorPagina() {
        const qtd = localStorage.getItem("qtd_por_pagina_respostas");
        if (qtd) {
          this.qtd_por_pagina = tryParseInt(qtd);
        }
      },
    },
    computed: {
      pageCount: function () {
        if (this.totalResultados && this.qtd_por_pagina > 0) {
          return Math.ceil(this.totalResultados / this.qtd_por_pagina);
        }
        return 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
/* Seus estilos podem ser mantidos aqui */
</style>